export default {
      id: "chevron-right-usage",
      viewBox: "0 0 6.265 11.531",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#chevron-right",
      toString: function () {
        return this.url;
      }
    }